import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { JobCard } from "./JobBoard";

export function SavedJobs() {
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get("/jobs/saved").then(({ data }) => setItems(data)).catch((e) => { toast.error(errMsg(e)); setItems([]); });
  }, []);
  const remove = (id) => api.delete(`/jobs/saved/${id}`)
    .then(() => { setItems((l) => l.filter((o) => o.id !== id)); toast.success("Offerta rimossa dalle salvate"); })
    .catch((e) => toast.error(errMsg(e)));
  if (!items) return <div className="h-32 animate-pulse rounded-2xl bg-slate-100" />;
  return (
    <div className="space-y-3" data-testid="saved-jobs">
      {!items.length && (
        <p className="rounded-2xl border border-slate-200 bg-white p-4 text-sm text-slate-500" data-testid="saved-jobs-empty">
          Non hai ancora salvato offerte. Apri la <Link to="/cafe" className="font-semibold text-emerald-700 hover:underline">Bacheca Lavoro nel Selvix Café</Link> e tocca il segnalibro su un annuncio.
        </p>
      )}
      <div className="grid gap-3 md:grid-cols-2 xl:grid-cols-3">{items.map((j) => <JobCard key={j.id} j={j} saved onSave={remove} />)}</div>
    </div>
  );
}
